function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 列表
 * @param pram
 * @constructor
 */
export function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = {
    tagName: pram.tagName,
    page: pram.page,
    limit: pram.limit
  };
  return request({
    url: '/admin/order/tag/list',
    method: 'GET',
    params: data
  });
}
var handSubmit = function handSubmit() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var tagName = datas.tagName,
    status = datas.status;
  return {
    tagName: tagName,
    status: status
  };
};

/**
 * 新增
 * @param pram
 * @constructor
 */
export function AddArticle(pram) {
  return request({
    url: '/admin/order/tag/add',
    method: 'post',
    data: handSubmit(pram)
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
export function UpdateArticle(pram) {
  return request({
    url: '/admin/order/tag/update',
    method: 'put',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}

/**
 * 删除
 * @param id
 * @constructor
 */
export function DelArticle(pram) {
  var data = {
    id: pram.id
  };
  return request({
    url: "/admin/order/tag/delete/".concat(pram.id),
    method: 'delete',
    params: data
  });
}

/**
 * 详情
 * @param id
 * @constructor
 */
export function getComDetail(id) {
  return request({
    url: "/admin/order/tag/get/".concat(id),
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 更改状态
 * @param id
 * @constructor
 */
export function updateState(id, status) {
  return request({
    url: "/admin/order/tag/status/".concat(id, "/").concat(status),
    method: 'put',
    params: {
      id: id,
      status: status
    }
  });
}

/**
 * 查询所有标签，选择用（只有启用的才返回）
 */
export function getSelectTag() {
  return request({
    url: '/admin/order/tag/select',
    method: 'GET'
  });
}

/**
 * 查询所有标签，绑定用（普通订单）
 */
export function bindTagDetails(childOrderNo) {
  return request({
    url: "/admin/order/tag/".concat(childOrderNo),
    method: 'GET'
  });
}

/**
 * 给订单绑定标签
 */
export function orderBindTag() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/order/tag',
    method: 'post',
    data: data
  });
}

/**
 * 查询所有标签，绑定用（三方订单）
 */
export function bindThirdTagDetails(orderNo) {
  return request({
    url: "/admin/order/virtual/tag/".concat(orderNo),
    method: 'GET'
  });
}

/**
 * 给订单绑定标签（三方）
 */
export function addVirtualTag(data) {
  return request({
    url: "/admin/order/virtual/tag",
    method: 'post',
    data: data
  });
}

/**
 * 获取订单标签的订单数据
 */
export function getTagBindOrder(params) {
  var _ref = params || {},
    _ref$dateRange = _ref.dateRange,
    dateRange = _ref$dateRange === void 0 ? [] : _ref$dateRange,
    limit = _ref.limit,
    page = _ref.page,
    orderNo = _ref.orderNo,
    skuCode = _ref.skuCode,
    spuName = _ref.spuName,
    status = _ref.status,
    tagId = _ref.tagId;
  var _dateRange = _slicedToArray(dateRange, 2),
    startTime = _dateRange[0],
    endTime = _dateRange[1];
  return request({
    url: '/admin/order/tag/_list',
    method: 'GET',
    params: {
      startTime: startTime,
      endTime: endTime,
      limit: limit,
      page: page,
      orderNo: orderNo,
      skuCode: skuCode,
      spuName: spuName,
      status: status,
      tagId: tagId
    }
  });
}

/**
 * 移除订单标签
 * @param {*} orderNo 
 * @returns 
 */
export function removeOrderTag(orderNo) {
  return request({
    url: "/admin/order/tag/remove/".concat(orderNo),
    method: 'post',
    data: {
      orderNo: orderNo
    }
  });
}